import React from 'react';

import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { FormattedMessage } from '@techstyle/react-intl';
import { useDomain } from '@techstyle/redux-core';

import { getAddedToBasketCount } from '../../utils/selectors';
import { Component as StaticIcon } from '../StaticIcon';

const FlagWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.green200};
  border-radius: 2px;
  color: ${({ theme }) => theme.colors.green700};
  margin-top: ${({ theme }) => theme.spacing.small}px;
`;

const FlagText = styled.p`
  align-items: center;
  display: flex;
  padding: 10px ${({ theme }) => theme.spacing.small}px;
`;

const FireIcon = styled(StaticIcon).attrs({
  size: 18,
  type: 'fire',
})`
  margin-right: ${({ theme }) => theme.spacing.tiny}px;
`;

const AtbCount = styled.span`
  margin-right: 4px;
`;

function AddedToBasketCountFlag({ product }) {
  const atbCount = useSelector(state =>
    getAddedToBasketCount(state, product.master_product_id)
  );
  const { isBorderfreeCustomer } = useSelector(state => state.borderfree);

  const { tld } = useDomain();
  const isUS = tld === '.com';
  const isEU = tld !== '.com' && !isBorderfreeCustomer;

  if (isEU & (atbCount >= 1)) {
    return (
      <FlagWrapper>
        <FlagText>
          <FireIcon />
          <AtbCount />
          <FormattedMessage
            id="global_checkout.eu_trending"
            defaultMessage="Trending"
          />
        </FlagText>
      </FlagWrapper>
    );
  } else if (isUS & (atbCount >= 50)) {
    return (
      <FlagWrapper>
        <FlagText>
          <FireIcon />
          <AtbCount>{atbCount}</AtbCount>
          <FormattedMessage
            id="global_checkout.added_to_basket_count"
            defaultMessage="people have this in their cart"
          />
        </FlagText>
      </FlagWrapper>
    );
  } else {
    return null;
  }
}

AddedToBasketCountFlag.propTypes = { addedToBasketCount: PropTypes.number };

export default AddedToBasketCountFlag;
